import { Component, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AbstractSpecificDataComponent } from '../abstract-specific-data.component';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class AbstractSpecificFieldComponent<T> extends AbstractSpecificDataComponent {
  metadata: any = {};

  @Input()
  isRequired?: boolean = false;

  @Input()
  override touchNonce?: number;

  control: FormControl<T | undefined | null>;

  constructor() {
    super();
    this.control = new FormControl<T | undefined>(undefined);
  }

  ngOnInit() {
    if (this.isRequired) {
      this.control.setValidators(Validators.required);
    }
    this.control.valueChanges.subscribe(value => {
      this.metadata[this.getDataName()] = value;
      this.onDataChange({
        dataSource: this.getDataName(),
        data: { isFormValid: this.isFormValid(), data: this.metadata },
      });
    });

    this.onDataChange({ dataSource: this.getDataName(), data: { isFormValid: this.isFormValid(), data: {} } });
  }

  isFormValid() {
    return this.control.valid || this.control.disabled;
  }
  markAsTouched() {
    this.control.markAsTouched();
  }

  override ngOnChanges(changes: SimpleChanges) {
    var data = changes['initialData']?.currentValue;
    if (data) {
      const dataName = this.getDataName();
      const dataValueString = data.data[this.getDataName()];
      if (dataValueString) {
        var value: T = this.wrapData(dataValueString);
        if (value) {
          this.control.setValue(value);
        }
      }
    }

    if (changes['touchNonce'] && !changes['touchNonce'].firstChange) {
      if (this.isRequired) {
        this.control.markAsTouched();
        this.control.updateValueAndValidity({ onlySelf: true });
      }
    }
  }

  abstract wrapData(value: string): T;
}
